module.exports = __webpack_public_path__ + "img/weddings_26_H.ee8d75a4.webp";